// src/utils/mathJaxRender.ts

/**
 * Trigger MathJax to typeset the page.
 * - If MathJax.typeset() exists it will be called (v2-style).
 * - Otherwise if MathJax.typesetPromise() exists it will be called and the Promise returned (v3-style).
 *
 * Returns a Promise when using typesetPromise, otherwise returns void.
 */
export default function mathJaxRender(): void | Promise<void> {
  const mj = window.MathJax;
  if (!mj) return;

  if (typeof mj.typeset === "function") {
    // v2-style: synchronous typeset
    try {
      return mj.typeset();
    } catch (e) {
      // guard in case typeset throws — swallow or log as desired
      // eslint-disable-next-line no-console
      console.warn("MathJax.typeset threw:", e);
      return;
    }
  }

  if (typeof mj.typesetPromise === "function") {
    // v3-style: return the Promise so callers can await if they want
    return mj.typesetPromise();
  }

  return;
}
